// extracted by mini-css-extract-plugin
module.exports = {"controlPane":"ControlPane_controlPane__Pl2ob","title":"ControlPane_title__1TaEu","metadata":"ControlPane_metadata__OCG_-"};